export const OTHER = 'OTHER';
export const OTHER_TRAVEL_TASK = 'OTHER_TRAVEL_TASK';

export const TRAVEL_TOPIC = 'TRAVEL';

export const TASK_TRAVER_FOLDER = 'Travel Folder';

export const dateFormat = 'DD/MMM/YYYY, h:mm A';

export const PROCESS = 'PROCESS';
export const QUALITY = 'QUALITY';
export const TO_DO = 'TO_DO';

export const TASKS_TYPES = [PROCESS, QUALITY, TO_DO];

export const HIGH_PRIORITY = 'HIGH';
export const MEDIUM_PRIORITY = 'MEDIUM';
export const LOW_PRIORITY = 'LOW';

export const HIGH_PRIORITY_LABEL = 'High';
export const MEDIUM_PRIORITY_LABEL = 'Medium';
export const LOW_PRIORITY_LABEL = 'Low';

export const taskPriorities = [
  { id: LOW_PRIORITY, name: LOW_PRIORITY_LABEL },
  { id: MEDIUM_PRIORITY, name: MEDIUM_PRIORITY_LABEL },
  { id: HIGH_PRIORITY, name: HIGH_PRIORITY_LABEL }
];

export const taskPriorityWeights = {
  [LOW_PRIORITY]: 3,
  [MEDIUM_PRIORITY]: 2,
  [HIGH_PRIORITY]: 1
};

export const tasksTypesMap = {
  [PROCESS]: 'Process',
  [QUALITY]: 'Quality',
  [TO_DO]: 'To-Do'
};

export const tasksStatuses = [
  { id: 'OPEN', name: 'Open' },
  { id: 'PENDING', name: 'Pending' },
  { id: 'COMPLETE', name: 'Complete' },
  { id: 'CANCELED', name: 'Canceled' }
];

export const tasksStatusesMap = tasksStatuses.reduce(function(accumulator, value) {
  return { ...accumulator, [value.id]: value };
}, {});

export const findTaskStatus = id => tasksStatuses.find(s => s.id === id) ?? null;

export const taskRoutes = Object.freeze([
  'Patients.Patient Profile.Patient Studies',
  'Patients.Patient Profile.Patient Studies.Reimbursement request',
  'Patients.Patient Profile.Patient Studies.Encounter Details',
  'Patients.Patient Profile.Patient Studies.Encounter Details.Study Manager Encounter Review',
  'Patients.Patient Profile.Patient Studies.Encounter Details.Investigator Encounter Review',
  'Patients.Patient Profile.Patient Studies.Encounter Details.Informed Consent',
  'Patients.Patient Profile.Patient Studies.Encounter Details.Procedure',
  'Patients.Patient Profile.Patient Studies.Encounter Details.Logs',
  'Patients.Patient Profile.Patient Studies.Completed Informed Consents',
  'Patients.Patient Profile.Patient Studies.Logs',
  'Patients.Patient Profile.Patient Studies.Logs.Row',
  'Patients.Patient Profile.Patient Studies.Encounter Details.Logs.Row',
  'Patients.Patient Profile.Patient Studies.Encounter Details.Table',
  'Patients.Patient Profile.Patient Studies.Patient Status',
  'Patients.Patient Profile.Patient Studies.Travel Request',
  'Worklist.Patient Profile.Patient Studies',
  'Worklist.Patient Profile.Patient Studies.Reimbursement request',
  'Worklist.Patient Profile.Patient Studies.Encounter Details',
  'Worklist.Patient Profile.Patient Studies.Encounter Details.Study Manager Encounter Review',
  'Worklist.Patient Profile.Patient Studies.Encounter Details.Investigator Encounter Review',
  'Worklist.Patient Profile.Patient Studies.Encounter Details.Informed Consent',
  'Worklist.Patient Profile.Patient Studies.Encounter Details.Procedure',
  'Worklist.Patient Profile.Patient Studies.Encounter Details.Logs',
  'Worklist.Patient Profile.Patient Studies.Completed Informed Consents',
  'Worklist.Patient Profile.Patient Studies.Logs',
  'Worklist.Patient Profile.Patient Studies.Logs.Row',
  'Worklist.Patient Profile.Patient Studies.Encounter Details.Logs.Row',
  'Worklist.Patient Profile.Patient Studies.Encounter Details.Table',
  'Worklist.Patient Profile.Patient Studies.Patient Status',
  'Investigator Worklist.Patient Profile.Patient Studies',
  'Investigator Worklist.Patient Profile.Patient Studies.Reimbursement request',
  'Investigator Worklist.Patient Profile.Patient Studies.Encounter Details',
  'Investigator Worklist.Patient Profile.Patient Studies.Encounter Details.Study Manager Encounter Review',
  'Investigator Worklist.Patient Profile.Patient Studies.Encounter Details.Investigator Encounter Review',
  'Investigator Worklist.Patient Profile.Patient Studies.Encounter Details.Informed Consent',
  'Investigator Worklist.Patient Profile.Patient Studies.Encounter Details.Procedure',
  'Investigator Worklist.Patient Profile.Patient Studies.Encounter Details.Logs',
  'Investigator Worklist.Patient Profile.Patient Studies.Completed Informed Consents',
  'Investigator Worklist.Patient Profile.Patient Studies.Logs',
  'Investigator Worklist.Patient Profile.Patient Studies.Logs.Row',
  'Investigator Worklist.Patient Profile.Patient Studies.Encounter Details.Logs.Row',
  'Investigator Worklist.Patient Profile.Patient Studies.Encounter Details.Table',
  'Investigator Worklist.Patient Profile.Patient Studies.Patient Status',
  'Study Manager Worklist.Patient Profile.Patient Studies',
  'Study Manager Worklist.Patient Profile.Patient Studies.Reimbursement request',
  'Study Manager Worklist.Patient Profile.Patient Studies.Encounter Details',
  'Study Manager Worklist.Patient Profile.Patient Studies.Encounter Details.Study Manager Encounter Review',
  'Study Manager Worklist.Patient Profile.Patient Studies.Encounter Details.Investigator Encounter Review',
  'Study Manager Worklist.Patient Profile.Patient Studies.Encounter Details.Informed Consent',
  'Study Manager Worklist.Patient Profile.Patient Studies.Encounter Details.Procedure',
  'Study Manager Worklist.Patient Profile.Patient Studies.Encounter Details.Logs',
  'Study Manager Worklist.Patient Profile.Patient Studies.Completed Informed Consents',
  'Study Manager Worklist.Patient Profile.Patient Studies.Logs',
  'Study Manager Worklist.Patient Profile.Patient Studies.Logs.Row',
  'Study Manager Worklist.Patient Profile.Patient Studies.Encounter Details.Logs.Row',
  'Study Manager Worklist.Patient Profile.Patient Studies.Encounter Details.Table',
  'Study Manager Worklist.Patient Profile.Patient Studies.Patient Status',
  'CRA Review.Encounter Review',
  'Travel Requests.Travel Request'
]);
